import { useState, useCallback, useEffect } from 'react';

export function useInviteModal() {
  const [isOpen, setIsOpen] = useState(false);

  // Debug log for state changes
  useEffect(() => {
  }, [isOpen]);

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    openModal,
    closeModal
  };
} 